<template>
	<div class="checkBoxWrap">
		<label>
			<input type="checkbox" :true-value="trueValue" :false-value="falseValue" :name="name" :id="name" v-model="value" v-on:change="cdTrigger" />
			<span v-html="item.label" class="labelChb"></span>
		</label>
	</div>
</template>
<script>
	import {mapState} from 'vuex';
	import DataForInput from '@/store/Form/longFormOptions';
	export default {
		name: "abtCheckBox",
		data(){ return { item:DataForInput[this.name], } },
		methods:{ cdTrigger(){ this.$palantir.trackInputBlur(this.name,this.valueVuex[this.name]); } },
		components:{ },
		computed:{
			isTrue(){ return this.value == this.trueValue; },
			...mapState({
				statusVuex: state => state.Form.workData,
				valueVuex:  state => state.Form.sendData,
			}),
			value: {
				get() { return this.valueVuex[this.name] },
				set(value) { let utiputi = { target: this.name, value: value }; this.$store.dispatch('saveSendData', utiputi); }
			}
		},
		props:{
			name:{ type: String, default:'', },
			trueValue:{ type: String, default: 'true' },
			falseValue:{ type: String, default: 'false' },
		}
	}
</script>

<style scoped>
label { display: flex; width: 100%; font-size: 1vw; }
label span { font-size: 3vw; }
input[type=checkbox] { background: #F5F5F5;appearance: none;position: relative;border-color: black;border-style: solid;}
input[type=checkbox]::before {content: '';display: none;appearance: none;position: absolute;top: 0.53vw;border-radius: 0;transform: rotate(45deg);border-right: .1rem solid #0D5740;border-bottom: .1rem solid #0D5740;}
input[type=checkbox]:checked::before {display: block;}
input[type=checkbox] {width: 7vw;height: 7vw;border-radius: .2rem;margin-right: .5rem;border-width: .05rem;}
input[type=checkbox]::before {width: 2.40vw;height: 3.6vw;left: 1.93vw}
@media (min-width: 768px) {
  label { font-size: 1vw; }
  label span { font-size: 1vw; color: #959595; }
  input[type=checkbox] {width: 1.5rem;height: 1.5rem;border-radius: .3rem;}
	input[type=checkbox]::before {width: .3rem;height: .6rem;left: .5rem;top: .2rem;}
}
</style>
